export default "__VITE_ASSET__D$Jzuy37__"